<template>
  <div class="bg-semantic-surface-container-lowest py-10 md:py-20 px-4 md:px-0">
    <ClientOnly>
      <div class="max-w-wrapper-lg m-auto" :class="wrapperClass">
        <Component
          :is="headerTag"
          class="text-2xl/[120%] md:text-4xl/[150%] text-center text-semantic-surface-on-surface font-semibold"
          :class="[headerTitleClass, { 'mb-2 md:mb-4': $slots['sub-header'] }]"
        >
          <slot name="header" />
        </Component>

        <p
          v-if="$slots['sub-header']"
          class="md:text-lg/[150%] text-center mb-6 lg:mb-10 max-w-wrapper-md mx-auto text-semantic-surface-on-surface"
          :class="subHeaderClass"
        >
          <slot name="sub-header" />
        </p>

        <div
          class="gap-4 md:gap-8 grid md:mt-10 mt-6"
          :class="[gridCount, cardWrapperMaxWidth, cardWrapperClass]"
        >
          <V2MoleculesCardFeatureCard
            v-for="(card, cardKey) in cards"
            :key="cardKey"
            :class="[cardClass, getWrapperClass(cardKey)]"
            :header-icon="getHeaderIcon(card)"
            :has-cta="Boolean(card.ctaBtnLabel)"
            :cta-btn-label="card.ctaBtnLabel"
            :cta-btn-to="card.url"
            :title="card.title"
            :icon-props="card.iconProps"
            :description="card.description"
            :text-align="card.textAlign"
            class="w-full max-w-full"
          />
        </div>

        <div
          v-if="$slots.footer"
          :class="footerClass"
          class="mt-10">
          <slot name="footer" />
        </div>
      </div>
    </ClientOnly>
  </div>
</template>

<script setup>
import V2IconsCheck from '~/components/v2/icons/Check.vue'

defineOptions({
  name: 'V2OrganismHomeGreatDeal'
})

const props = defineProps({
  cards: {
    type: Array,
    required: true,
    validator: () => []
  },

  headerTag: {
    type: String,
    default: 'p',
    validator: value =>
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div'].includes(value)
  },

  colCount: {
    type: Number,
    default: 3,
    validator: value => [1, 2, 3, 4].includes(value)
  },

  cardWrapperMaxWidth: {
    type: String,
    default: ''
  },

  cardWrapperClass: {
    type: String,
    default: ''
  },

  cardClass: {
    type: String,
    default: ''
  },

  titleClass: {
    type: String,
    default: ''
  },

  descriptionClass: {
    type: String,
    default: ''
  },

  footerClass: {
    type: String,
    default: ''
  },

  headerTitleClass: {
    type: String,
    default: ''
  },

  wrapperClass: {
    type: String,
    default: ''
  },

  subHeaderClass: {
    type: String,
    default: ''
  },

  hideHeaderIcon: {
    type: Boolean,
    default: false
  },

  defaultHeaderIcon: {
    type: Boolean,
    default: false
  }
})

const gridCount = computed(() => {
  return getKey(props.colCount, {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4'
  })
})

const getHeaderIcon = card => {
  if (!props.hideHeaderIcon)
    return props.defaultHeaderIcon ? V2IconsCheck : card.icon
  return ''
}

const getWrapperClass = computed(() => index => {
  const total = props.cards.length
  const colCount = props.colCount

  const isLast = index === total - 1
  const hasRemainder = total % colCount !== 0

  const classes = ['max-w-full']

  // If last card AND it’s the only one in the last row
  if (hasRemainder && isLast && total % colCount === 1) {
    classes.push(`md:col-span-${colCount}`)
  }

  return classes.join(' ')
})
</script>
